import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import Customers from "@hydrologiq/customers/views/CustomersPaginated"
import { Provider } from "react-redux"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"
import { CustomerProvider } from "./providers/CustomerProvider"
import Providers from "@hydrologiq/shared/providers/Providers"
import { RouteProvider, Section } from "@hydrologiq/shared/providers/RouteProvider"
import CustomerForecast from "./views/CustomerForecast"
import CustomerSelection from "./components/selection/CustomerSelection"
import ScrollToTop from "@hydrologiq/shared/ScrollToTop"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"
import Customer from "./views/Customer"
import CustomerOrders from "./views/CustomerOrders"
import CustomerPerformance from "./views/CustomerPerformance"
import CustomerSite from "./views/CustomerSite"
import store from "./state/store"
import System from "@hydrologiq/systems/views/System"
import SystemMonitoring from "@hydrologiq/systems/views/SystemMonitoring"
import SystemReporting from "@hydrologiq/systems/views/SystemReporting"
import SystemReport from "@hydrologiq/systems/views/SystemReport"
import SystemForecast from "@hydrologiq/systems/views/SystemForecast"
import SystemAlertsPerformance from "@hydrologiq/systems/views/SystemAlertsPerformance"
import Settings from "@hydrologiq/systems/views/Settings"
import { SystemProvider } from "@hydrologiq/systems/providers/SystemProvider"
import CustomerReporting from "./views/CustomerReporting"

function Routing(props: { basePath?: string; user?: DashboardUser; container?: React.RefObject<HTMLElement> }) {
  const sectionPath = "customers"
  const { basePath = sectionPath, container } = props
  const customerAdvancedFeatureEnabled = useGetFeature("customer_advanced")
  const customerReportingFeatureEnabled = useGetFeature("customer_reporting")
  const hideReports = useGetFeature("hide_reports_system")
  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        {!basePath && <Route path={sectionPath} element={<Navigate to={"/"} />} />}
        <Route
          path={basePath}
          element={
            <RouteProvider route={basePath} section={Section.CUSTOMERS}>
              <Providers container={container}>
                <CustomerProvider>
                  <SystemProvider>
                    <CustomerSelection />
                  </SystemProvider>
                </CustomerProvider>
              </Providers>
            </RouteProvider>
          }
        >
          <Route index element={<Customers />} />
          <Route path=":customerId" element={<Outlet />}>
            <Route index element={<Customer />} />
            <Route path="orders" element={<CustomerOrders />} />
            {customerAdvancedFeatureEnabled && <Route path="performance" element={<CustomerPerformance />} />}
            {customerAdvancedFeatureEnabled && <Route path="forecast" element={<CustomerForecast />} />}

            {customerReportingFeatureEnabled && <Route path="reporting" element={<CustomerReporting />} />}

            <Route path="sites" element={<Outlet />}>
              <Route index element={<Customer />} />
              <Route path=":siteId" element={<Outlet />}>
                <Route index element={<CustomerSite />} />
                <Route path="systems" element={<Outlet />}>
                  <Route path=":systemId" element={<Outlet />}>
                    <Route index element={<System />} />
                    <Route path="forecasting" element={<SystemForecast />} />
                    <Route path="monitoring" element={<SystemMonitoring />} />
                    {!hideReports && <Route path="reporting" element={<SystemReport />} />}
                    <Route path="download" element={<SystemReporting />} />
                    <Route path="alerts" element={<SystemAlertsPerformance />} />
                    <Route path="settings" element={<Settings />} />
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </Provider>
  )
}

export default Routing
